import { useStore } from "@/core/services/store";
import { setXentralConfig } from "@/composables/useSalesChannelManagementApp";
import { isEmpty } from "lodash";
import { computed } from "vue";
import { Toast } from "@/core/plugins/swal";
import i18n from "@/core/plugins/vue-i18n";
import { useApp } from "@/components/ExternalApps/SalesChannelManagementApp/composables/useApp";
import useOauth from "@/components/ExternalApps/SalesChannelManagementApp/composables/useOauth";

export const useEtsyOauth = () => {
  const store = useStore();
  const { base64ToUtf8, reauthorizationUrl } = useOauth();
  const { selectIntegration } = useApp();

  const xentralConfigData = computed(
    () => store.getters.xentralConfig?.data ?? []
  );
  const queryState = computed(() =>
    base64ToUtf8(xentralConfigData.value?.["state"])
  );

  function getAccessToken() {
    const xentralConfig = store.getters.xentralConfig?.data;
    const fromUrl = xentralConfig?.baseUrl?.replace(/\/+$/, "") || "";
    const endpoint = xentralConfig?.xentralAppUri || "";
    const target = `${fromUrl}/${endpoint.replace(/^\/+/, "")}`;

    const url = reauthorizationUrl(
      store.getters?.selectedIntegration?.id,
      target
    );

    resetXentralConfig();

    window.open(url, "_parent");
  }

  async function applyEtsyOAuthValues() {
    if (isEmpty(queryState.value)) return;

    const selectedIntegration = store.getters.integrationProject(
      queryState.value.project_id
    );
    await selectIntegration(
      selectedIntegration,
      "settings",
      "settings",
      "wizard"
    );

    await Toast.fire({
      icon: "success",
      title: i18n.t("salesChannelManagementApp.newTokenSuccess")
    });

    resetXentralConfig();
  }

  function resetXentralConfig() {
    const xentralData = store.getters.xentralConfig;

    const newData = { ...xentralData.data };
    delete newData.state;

    setXentralConfig({ ...xentralData, data: newData });
  }

  return {
    getAccessToken,
    applyEtsyOAuthValues
  };
};
